import React from 'react';
import './Styles.css';

const MenuListItem = ({ text, onClick, disabled = false }) => {
  return (
    <li
      className={`menu-list-item-container ${
        disabled ? 'disabled-menu-list-item' : 'clickable'
      }`}
      onClick={disabled ? () => {} : onClick}>
      {text}
    </li>
  );
};

export default MenuListItem;
